/** Etiquetas y clases CSS para estado de vigencia del catálogo de planes. */

export function planStatusDisplay(plan) {
  if ((plan?.status || "").toLowerCase() === "inactive") {
    return { label: "Inactivo", className: "plan-status-inactive" };
  }
  switch (plan?.expiry_status) {
    case "expired":
      return { label: "Vencido", className: "plan-status-expired" };
    case "warn_30":
      return {
        label: plan.days_until_expiry != null ? `Activo · ${plan.days_until_expiry}d` : "Por vencer (≤30d)",
        className: "plan-status-warn-30",
      };
    case "warn_60":
      return {
        label: plan.days_until_expiry != null ? `Activo · ${plan.days_until_expiry}d` : "Por vencer (≤60d)",
        className: "plan-status-warn-60",
      };
    case "warn_90":
      return {
        label: plan.days_until_expiry != null ? `Activo · ${plan.days_until_expiry}d` : "Por vencer (≤90d)",
        className: "plan-status-warn-90",
      };
    default:
      return { label: "Activo", className: "plan-status-active" };
  }
}

export function isPlanAssignable(plan) {
  if ((plan?.status || "").toLowerCase() !== "active") return false;
  return plan?.expiry_status !== "expired";
}

export function formatPlanParams(plan) {
  const docs =
    plan.max_documents_monthly == null ? "Docs ilimitados" : `${plan.max_documents_monthly} docs/mes`;
  const fallback =
    plan.fallback_tokens_model === "PAY_AS_YOU_GO"
      ? "Fallback PAYG"
      : `Fallback FLAT (${Number(plan.fallback_tokens_included || 0).toLocaleString("es-AR")} máx.)`;
  return [
    plan.arca_enabled ? "ARCA" : "Sin ARCA",
    plan.copilot_enabled ? "Copilot" : "Sin Copilot",
    docs,
    fallback,
  ].join(" · ");
}
